import { SxProps, Theme } from '@mui/material';

export const boxPromo1SX: SxProps<Theme> = {
	backgroundColor: 'transparent',
	border: '1px solid #900005',
	borderRadius: '4px',
	opacity: 1,
	marginTop: '14px !important',
	width: {
		xs: '100% !important',
		sm: 'fit-content',
	},
	paddingLeft: '13px',
	paddingRight: '13px',
};

export const promo1TitleBoxSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#900005',
	fontWeight: 'bold',
	opacity: 1,
	marginTop: '4px',
	marginBottom: '4px',
};

export const promo1DescriptionBoxSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#900005',
	fontWeight: '600',
	opacity: 1,
	marginTop: '4px',
	marginBottom: '4px',
	display: 'inline',
};

export const boxPromo2SX: SxProps<Theme> = {
	backgroundColor: '#FFF9D7',
	border: '0px',
	borderRadius: {
		xs: '0px',
		sm: '15px',
	},
	opacity: 1,
	marginTop: {
		xs: '0px',
		sm: '14px !important',
	},
	width: {
		xs: '100% !important',
		sm: 'fit-content',
	},
	paddingLeft: '13px',
	paddingRight: '13px',
};

export const promo2TitleBoxSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#BE3C09',
	fontWeight: 'bold',
	opacity: 1,
	marginTop: '4px',
	marginBottom: '4px',
};

export const promo2DescriptionBoxSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-default)',
	letterSpacing: '0px',
	color: '#4E3724',
	fontWeight: '600',
	opacity: 1,
	marginTop: '4px',
	marginBottom: '4px',
	display: 'inline',
};
